import Users from './';
export default [
  {
    type: 'private',
    path: '/users',
    component: Users,
    exact: true,
    private: true,
    admin: true
  }
];



// WEBPACK FOOTER //
// ./src/views/users/_routes.js